(function () {
  function isAuthenticated() {
    try {
      if (
        window.authSession &&
        typeof window.authSession.isLoggedIn === 'function' &&
        window.authSession.isLoggedIn()
      ) {
        return true;
      }
    } catch (error) {}
    var user = window.userData || {};
    return !!(user.id || user.email || user.secret || user.api_key);
  }

  function isGalleryComposerAvailable() {
    return !!document.getElementById('create-post-dialog');
  }

  function currentPathWithQuery() {
    return window.location.pathname + window.location.search;
  }

  function openAuthForPostComposer(event) {
    if (typeof window.showSignupDialog === 'function') {
      window.showSignupDialog(event);
      return;
    }
    window.location.href = '/login?next=' + encodeURIComponent(currentPathWithQuery());
  }

  function getDialogParts() {
    return {
      dialog: document.getElementById('shared-post-dialog'),
      text: document.getElementById('shared-post-text'),
      input: document.getElementById('shared-post-media-input'),
      linkPreview: document.getElementById('shared-post-link-preview'),
      preview: document.getElementById('shared-post-preview'),
      nsfw: document.getElementById('shared-post-nsfw-toggle'),
      addMedia: document.getElementById('shared-post-add-media-btn'),
      addEmoji: document.getElementById('shared-post-add-emoji-btn'),
      submit: document.getElementById('shared-post-submit-btn'),
    };
  }

  function closeDrawerIfOpen() {
    document
      .querySelectorAll('.mdl-layout__obfuscator.is-visible, .mdl-layout__drawer.is-visible')
      .forEach(function (element) {
        element.classList.remove('is-visible');
      });
  }

  function showComposerDialog() {
    if (isGalleryComposerAvailable()) {
      var galleryDialog = document.getElementById('create-post-dialog');
      if (galleryDialog && typeof galleryDialog.showModal === 'function') {
        galleryDialog.showModal();
      }
      closeDrawerIfOpen();
      return;
    }
    var parts = getDialogParts();
    if (!parts.dialog || typeof parts.dialog.showModal !== 'function') {
      return;
    }
    parts.dialog.showModal();
    parts.text && parts.text.focus();
    closeDrawerIfOpen();
  }

  function clearSharedComposer() {
    var parts = getDialogParts();
    if (parts.text) {
      parts.text.innerHTML = '';
    }
    if (parts.input) {
      parts.input.value = '';
    }
    if (parts.nsfw) {
      parts.nsfw.checked = false;
    }
    if (parts.preview) {
      parts.preview.innerHTML = '';
      parts.preview.classList.remove('is-visible');
    }
    if (parts.linkPreview) {
      parts.linkPreview.innerHTML = '';
      parts.linkPreview.hidden = true;
    }
    window._sharedPostFiles = [];
    window._sharedPostPreviewURL = '';
  }

  function escapeHtml(text) {
    var div = document.createElement('div');
    div.textContent = text;
    return div.innerHTML;
  }

  function firstPostURL(text) {
    var match = String(text || '').match(/https?:\/\/[^\s<>"']+/i);
    if (!match) return '';
    var value = match[0].replace(/[.,!?;:]+$/g, '');
    [['(', ')'], ['[', ']'], ['{', '}']].forEach(function (pair) {
      while (value.endsWith(pair[1]) && value.split(pair[1]).length > value.split(pair[0]).length) {
        value = value.slice(0, -1);
      }
    });
    return value;
  }

  function displayPostURL(url) {
    var display = String(url || '').replace(/^https?:\/\//i, '');
    try {
      var parsed = new URL(url);
      if (!parsed.pathname || parsed.pathname === '/') display = display.replace(/\/$/, '');
    } catch (error) {}
    return display;
  }

  function renderSharedLinkPreview(url, data) {
    var parts = getDialogParts();
    if (!parts.linkPreview || window._sharedPostPreviewURL !== url) return;
    var domain = displayPostURL(url).split('/')[0].replace(/^www\./i, '');
    var imageURL = '';
    try {
      imageURL = data && data.image ? new URL(data.image, url).href : '';
    } catch (error) {}
    var image = imageURL ? '<img class="shared-post-link-image" src="' + escapeHtml(imageURL) + '" alt="">' :
      '<span class="shared-post-link-icon"><i class="material-icons">link</i></span>';
    parts.linkPreview.innerHTML =
      '<a class="shared-post-link-card" href="' + escapeHtml(url) + '" target="_blank" rel="noopener">' +
        image +
        '<span class="shared-post-link-copy">' +
          '<strong>' + escapeHtml((data && data.title) || domain) + '</strong>' +
          ((data && data.description) ? '<span>' + escapeHtml(String(data.description).slice(0, 140)) + '</span>' : '') +
          '<small>' + escapeHtml(displayPostURL(url)) + '</small>' +
        '</span>' +
        '<i class="material-icons shared-post-link-open">open_in_new</i>' +
      '</a>';
    parts.linkPreview.hidden = false;
  }

  function updateSharedLinkPreview() {
    var parts = getDialogParts();
    if (!parts.text || !parts.linkPreview) return;
    var url = firstPostURL(parts.text.innerText || parts.text.textContent || '');
    if (!url) {
      window._sharedPostPreviewURL = '';
      parts.linkPreview.innerHTML = '';
      parts.linkPreview.hidden = true;
      return;
    }
    if (window._sharedPostPreviewURL === url) return;
    window._sharedPostPreviewURL = url;
    renderSharedLinkPreview(url, null);
    fetch('/api/link-preview?url=' + encodeURIComponent(url))
      .then(function (response) { return response.ok ? response.json() : null; })
      .then(function (data) { renderSharedLinkPreview(url, data); })
      .catch(function () { renderSharedLinkPreview(url, null); });
  }

  function renderPreviews(files) {
    var parts = getDialogParts();
    if (!parts.preview || !files || !files.length) {
      return;
    }
    parts.preview.innerHTML = '';
    parts.preview.classList.add('is-visible');
    for (var i = 0; i < files.length; i++) {
      (function (file, idx) {
        var objectUrl = URL.createObjectURL(file);
        var item = document.createElement('div');
        item.className = 'shared-post-preview-item';
        item.dataset.idx = idx;
        var media = file.type && file.type.indexOf('video/') === 0
          ? '<video controls src="' + objectUrl + '"></video>'
          : '<img src="' + objectUrl + '" alt="Post preview">';
        item.innerHTML = media +
          '<button type="button" class="shared-post-preview-remove" aria-label="Remove" data-idx="' + idx + '">' +
          '<span class="material-icons">close</span></button>';
        parts.preview.appendChild(item);
      })(files[i], i);
    }
    parts.preview.addEventListener('click', function (e) {
      var btn = e.target && e.target.closest ? e.target.closest('.shared-post-preview-remove') : null;
      if (!btn) return;
      var idx = parseInt(btn.dataset.idx, 10);
      window._sharedPostFiles = (window._sharedPostFiles || []).filter(function (_, i) { return i !== idx; });
      renderPreviews(window._sharedPostFiles);
      if (!window._sharedPostFiles.length) {
        if (parts.input) parts.input.value = '';
        parts.preview.classList.remove('is-visible');
      }
    }, { once: false });
  }

  function setSubmitting(isSubmitting) {
    var parts = getDialogParts();
    if (!parts.submit) {
      return;
    }
    parts.submit.disabled = !!isSubmitting;
    parts.submit.classList.toggle('is-disabled', !!isSubmitting);
    parts.submit.innerHTML = isSubmitting
      ? '<i class="material-icons">hourglass_top</i> Posting'
      : '<i class="material-icons">send</i> Post';
  }

  function notify(message) {
    if (typeof window.showNotification === 'function') {
      window.showNotification(message);
      return;
    }
    if (typeof window.alert === 'function') {
      window.alert(message);
    }
  }

  async function submitSharedPost() {
    var parts = getDialogParts();
    if (!parts.text) {
      return;
    }
    var text = (parts.text.innerText || parts.text.textContent || '').trim();
    var files = window._sharedPostFiles || [];
    if (!text && !files.length) {
      notify('Add some content');
      return;
    }

    var formData = new FormData();
    formData.append('text', text);
    for (var i = 0; i < files.length; i++) {
      formData.append('media', files[i]);
    }
    if (files.length === 1) {
      formData.append('media_type', files[0].type && files[0].type.indexOf('video/') === 0 ? 'video' : 'image');
    }
    if (parts.nsfw && parts.nsfw.checked) {
      formData.append('is_nsfw', 'true');
    }

    setSubmitting(true);
    try {
      var response = await fetch('/api/create-post', {
        method: 'POST',
        body: formData,
      });
      if (!response.ok) {
        throw new Error('create-post failed');
      }
      var data = await response.json();
      clearSharedComposer();
      parts.dialog && parts.dialog.close();
      var postId = data && (data.ID || data.id);
      window.location.href = postId ? '/p/' + postId : '/gallery';
    } catch (error) {
      notify('Post failed');
    } finally {
      setSubmitting(false);
    }
  }

  function bindSharedComposer() {
    var parts = getDialogParts();
    if (!parts.dialog || parts.dialog.dataset.postComposerBound === 'true') {
      return;
    }
    parts.dialog.dataset.postComposerBound = 'true';
    parts.addMedia &&
      parts.addMedia.addEventListener('click', function () {
        parts.input && parts.input.click();
      });
    parts.input &&
      parts.input.addEventListener('change', function () {
        var chosen = Array.from(parts.input.files || []);
        if (!chosen.length) return;
        var existing = window._sharedPostFiles || [];
        var combined = existing.concat(chosen).slice(0, 10);
        window._sharedPostFiles = combined;
        renderPreviews(combined);
      });
    parts.addEmoji &&
      parts.addEmoji.addEventListener('click', function () {
        if (typeof window.openEmojiModal === 'function') {
          window.openEmojiModal(parts.text);
        } else {
          var emojiDialog = document.getElementById('emoji-modal-dialog');
          if (emojiDialog && typeof emojiDialog.showModal === 'function') {
            emojiDialog.showModal();
          }
        }
      });
    parts.submit &&
      parts.submit.addEventListener('click', function () {
        submitSharedPost();
      });
    parts.dialog.addEventListener('close', function () {
      setSubmitting(false);
    });

    var dropZone = document.getElementById('shared-post-drop-zone') || parts.dialog;
    dropZone.addEventListener('dragover', function (e) {
      e.preventDefault();
      dropZone.classList.add('drag-over');
    });
    dropZone.addEventListener('dragleave', function (e) {
      if (!dropZone.contains(e.relatedTarget)) {
        dropZone.classList.remove('drag-over');
      }
    });
    dropZone.addEventListener('drop', function (e) {
      e.preventDefault();
      dropZone.classList.remove('drag-over');
      var files = Array.from(e.dataTransfer.files || []).filter(function (f) {
        return f.type.startsWith('image/') || f.type.startsWith('video/');
      });
      if (!files.length) return;
      var combined = (window._sharedPostFiles || []).concat(files).slice(0, 10);
      window._sharedPostFiles = combined;
      renderPreviews(combined);
    });

    parts.text && parts.text.addEventListener('paste', function (e) {
      var items = e.clipboardData && e.clipboardData.items;
      if (!items) return;
      var imageFiles = [];
      for (var i = 0; i < items.length; i++) {
        if (items[i].kind === 'file' && items[i].type.startsWith('image/')) {
          var f = items[i].getAsFile();
          if (f) imageFiles.push(f);
        }
      }
      if (!imageFiles.length) return;
      e.preventDefault();
      var combined = (window._sharedPostFiles || []).concat(imageFiles).slice(0, 10);
      window._sharedPostFiles = combined;
      renderPreviews(combined);
    });
    var linkPreviewTimer;
    parts.text && parts.text.addEventListener('input', function () {
      clearTimeout(linkPreviewTimer);
      linkPreviewTimer = setTimeout(updateSharedLinkPreview, 350);
    });
  }

  function handleComposerTrigger(event) {
    event.preventDefault();
    event.stopPropagation();
    if (!isAuthenticated()) {
      openAuthForPostComposer(event);
      return false;
    }
    bindSharedComposer();
    showComposerDialog();
    return false;
  }

  function initPostComposer() {
    bindSharedComposer();
    if (document.body && document.body.dataset && document.body.dataset.postComposerDelegated !== 'true') {
      document.body.dataset.postComposerDelegated = 'true';
      document.addEventListener('click', function (event) {
        var trigger = event.target && event.target.closest
          ? event.target.closest('.drawer-new-post')
          : null;
        if (!trigger) {
          return;
        }
        handleComposerTrigger(event);
      });
    }
    if (new URLSearchParams(window.location.search).get('compose') === '1') {
      setTimeout(function () {
        if (isAuthenticated()) {
          bindSharedComposer();
          showComposerDialog();
        }
      }, 60);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initPostComposer);
  } else {
    initPostComposer();
  }

  window.openSharedPostComposer = handleComposerTrigger;
  window.refreshPostComposerTriggers = function () {};
})();
